import { api } from "../base";
import type { IOptionsReconResponse } from "@pulse-ui/codegen-v2/generated_ts/options_recon";

export {
  OptionsReconContractKey,
  OptionsReconDealBucket,
  OptionsReconFindingKind,
  OptionsReconPositionBucket,
  type IOptionsReconAccount,
  type IOptionsReconDealCensus,
  type IOptionsReconDealFinding,
  type IOptionsReconPositionCensus,
  type IOptionsReconPositionFinding,
  type IOptionsReconResolvedFinding,
  type IOptionsReconResponse,
  type IOptionsReconSources,
  type IOptionsReconUnresolvedContract,
} from "@pulse-ui/codegen-v2/generated_ts/options_recon";

// Served by trading-ops-server GET /api/trading-ops/v1/options-recon; Risk or Admin only.
const optionsReconEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getOptionsRecon: build.query<IOptionsReconResponse, void>({
      query: () => ({
        url: "/api/trading-ops/v1/options-recon",
      }),
    }),
  }),
});

export const { useGetOptionsReconQuery } = optionsReconEndpoints;
